export enum IndeedErrors {
    emailVerificationRequired = 'emailVerificationRequired',
    accessDenied = 'accessDenied',
    invalidCompany = 'invalid',
    generalError = 'error',
    hasIntegration = 'hasIntegration',
}
